import { render, staticRenderFns } from "./viewCustomer.vue?vue&type=template&id=123213db"
import script from "./viewCustomer.vue?vue&type=script&lang=js"
export * from "./viewCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports